import { useState } from "react";

const MessagePopup = ({ isOpen, onClose, title, message, type, details }) => {
  const [showDetails, setShowDetails] = useState(false);
  if (!isOpen) return null;

  const icons = {
    error: '⚠️',
    success: '✓',
    info: 'ℹ️',
    warning: '⚠️'
  };

  const colors = {
    error: { bg: '#fee2e2', border: '#dc2626', title: '#991b1b' },
    success: { bg: '#dcfce7', border: '#16a34a', title: '#166534' },
    info: { bg: '#e0f2fe', border: '#0284c7', title: '#075985' },
    warning: { bg: '#fef3c7', border: '#d97706', title: '#92400e' }
  };

  const color = colors[type] || colors.info;
  const hasDetails = details != null && String(details).trim() !== '';

  return (
    <div className="popup-overlay" onClick={onClose} style={{ zIndex: 2000000 }}>
      <div
        className="popup-modal"
        onClick={e => e.stopPropagation()}
        style={{ borderColor: color.border }}
      >
        <div className="popup-header" style={{ background: color.border }}>
          <span className="popup-icon">{icons[type]}</span>
          <span className="popup-title">{title || (type === 'error' ? 'Erreur' : type === 'success' ? 'Succes' : 'Information')}</span>
        </div>
        <div className="popup-content" style={{ background: color.bg }}>
          <p style={{ whiteSpace: 'pre-line' }}>{message}</p>

          {hasDetails && (
            <div style={{ marginTop: 10 }}>
              <button
                type="button"
                data-testid="popup-toggle-details"
                onClick={() => setShowDetails(v => !v)}
                style={{
                  background: 'transparent', border: 'none', cursor: 'pointer',
                  color: color.title, fontWeight: 600, fontSize: 13, padding: 0,
                  textDecoration: 'underline', display: 'inline-flex', alignItems: 'center', gap: 6
                }}
              >
                {showDetails ? '▾ Masquer le détail technique' : '▸ Voir le détail technique'}
              </button>

              {showDetails && (
                <pre
                  data-testid="popup-details-content"
                  style={{
                    marginTop: 8, maxHeight: 220, overflow: 'auto',
                    background: '#1e1e1e', color: '#e6e6e6', borderRadius: 6,
                    padding: '10px 12px', fontSize: 12, lineHeight: 1.5,
                    whiteSpace: 'pre-wrap', wordBreak: 'break-word',
                    fontFamily: 'ui-monospace, SFMono-Regular, Menlo, Consolas, monospace',
                    border: `1px solid ${color.border}`
                  }}
                >
                  {String(details)}
                </pre>
              )}
            </div>
          )}
        </div>
        <div className="popup-footer">
          <button className="popup-btn" data-testid="popup-ok-button" onClick={onClose} style={{ background: color.border }}>
            OK
          </button>
        </div>
      </div>
    </div>
  );
};

export default MessagePopup;
